// extracted by mini-css-extract-plugin
export var addressFields = "_oq-0";
export var animationContainer = "_oq-1";
export var footer = "_oq-2";
export var lineItems = "_oq-3";
export var modalContent = "_oq-4";
export var orderName = "_oq-5";
export var strong = "_oq-6";
export var warning = "_oq-7";